/** @type {NodeListOf<HTMLElement>} */
const headingWrapper = document.querySelectorAll('.accordion-heading--wrapper');

headingWrapper.forEach(button => {
  /** @this {HTMLElement} */
  button.addEventListener('click', function() {
    const content = this.nextElementSibling;
    /** @type {HTMLElement} */
    const plus = button.querySelector('.icon-plus');
    /** @type {HTMLElement} */
    const minus = button.querySelector('.icon-minus')

    content.classList.toggle('active');
    if(plus.style.display === "none"){
      minus.style.display = "none";
      plus.style.display = "flex";
    } else {
      plus.style.display = "none";
      minus.style.display = "flex";
    }
  })
});
